import { BaSeTheme } from '@base/react';
import * as React from 'react';

export function useUtilsService() {
  const isNotEmpty = React.useCallback((value) => {
    return !!value?.trim?.() ?? false;
  }, []);

  //Remove espaço, acentos e converte em maiúsculas
  const formatedTextUppercase = React.useCallback((value) => {
    if (!value) return '';
    return value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, '')
      .toUpperCase();
  }, []);

  const formatedTextLowercase = React.useCallback((value) => {
    if (!value) return '';
    return value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, '')
      .toLowerCase();
  }, []);

  const tagTypeAccount = React.useCallback(
    (value) => {
      const tipoTag = {
        CONTACORRENTE: BaSeTheme.colors.institucionais.azulSebrae60,
        CONTAPOUPANCA: BaSeTheme.colors.feedbackInterface.sucesso20,
        CARTAODECREDITO: BaSeTheme.colors.gestao.planejamento,
      };
      return (
        tipoTag?.[formatedTextUppercase(value)] ??
        BaSeTheme.colors.institucionais.azulSebrae60
      );
    },
    [formatedTextUppercase],
  );

  const formatPhoneNumber = React.useCallback((phoneNumber) => {
    if (!phoneNumber) return;

    phoneNumber = phoneNumber.replace(/\D/g, '');
    phoneNumber = phoneNumber.replace(/(\d{2})(\d)/, '($1) $2');
    if (phoneNumber.length > 13) {
      phoneNumber = phoneNumber.replace(/(\d)(\d{4})(\d{4})$/, '$1 $2-$3');
    } else {
      phoneNumber = phoneNumber.replace(/(\d)(\d{4})$/, '$1-$2');
    }

    return phoneNumber;
  }, []);

  const formatDate = React.useCallback(
    (date, showHour = false, showDate = false) => {
      if (!date) return;
      const dateFormat = new Intl.DateTimeFormat().format(new Date(date));
      const hourFormat = new Intl.DateTimeFormat('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      }).format(new Date(date));

      const isDateHour = showDate && showHour;
      const onlyHour = !showDate && showHour;

      return isDateHour
        ? `${dateFormat} - ${hourFormat}`
        : onlyHour
        ? hourFormat
        : dateFormat;
    },
    [],
  );

  const validateEmail = React.useCallback((email) => {
    const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/; // https://www.w3resource.com/javascript/form/email-validation.php
    return emailRegex.test(email) && email;
  }, []);

  const parseValue = React.useCallback((value) => {
    return isNaN(Number(value)) ? value : Number(value);
  }, []);

  const capitalizeFirstLetter = React.useCallback((string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }, []);

  const formatCnpj = React.useCallback((value) => {
    if (!value) return '';

    const alphanumeric = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    const hasLetters = /[A-Z]/.test(alphanumeric);
    const cleaned = hasLetters ? alphanumeric : value.replace(/\D/g, '');

    let formatted = cleaned.slice(0, 14);

    if (formatted.length > 2) {
      formatted = formatted.slice(0, 2) + '.' + formatted.slice(2);
    }
    if (formatted.length > 6) {
      formatted = formatted.slice(0, 6) + '.' + formatted.slice(6);
    }
    if (formatted.length > 10) {
      formatted = formatted.slice(0, 10) + '/' + formatted.slice(10);
    }
    if (formatted.length > 15) {
      formatted = formatted.slice(0, 15) + '-' + formatted.slice(15);
    }

    return formatted;
  }, []);

  const validateCnpj = React.useCallback((cnpj) => {
    if (!cnpj) return true;

    const cleaned = cnpj.replace(/[^a-zA-Z0-9]/g, '');

    if (cleaned.length !== 14) return false;

    const hasLetters = /[A-Z]/i.test(cleaned);

    if (hasLetters) {
      const firstTwelve = cleaned.slice(0, 12);
      if (!/^[A-Z0-9]{12}$/i.test(firstTwelve)) return false;

      const lastTwo = cleaned.slice(12);
      if (!/^\d{2}$/.test(lastTwo)) return false;

      return true;
    } else {
      return /^\d{14}$/.test(cleaned);
    }
  }, []);

  const useFormatCnpj = (value) => {
    return React.useMemo(() => formatCnpj(value), [value]);
  };

  return {
    isNotEmpty,
    formatedTextLowercase,
    formatedTextUppercase,
    tagTypeAccount,
    formatPhoneNumber,
    formatDate,
    validateEmail,
    parseValue,
    capitalizeFirstLetter,
    formatCnpj,
    validateCnpj,
    useFormatCnpj,
  };
}
